import produce from 'immer';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ConsultarBCadastroState } from './types';

export const INITIAL_STATE: ConsultarBCadastroState = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): ConsultarBCadastroState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_BCADASTRO_REQUEST: {
				draft.status = 100;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.CONSULTAR_BCADASTRO_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}
			case Types.CONSULTAR_BCADASTRO_FAILURE: {
				draft.status = 400;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.CONSULTAR_BCADASTRO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
